<div matRipple [matRippleColor]="'accent'" [matRippleCentered]="false">
  <span class="icon-badge" [matBadge]="itemCount()" [matBadgeDescription]="'Items in cart: ' + itemCount()">
    <mat-icon class="icon material-symbols-outlined" aria-hidden="true">shopping_cart</mat-icon>
  </span>
</div>
